import React, {
  useState,
  useEffect,
useReducer,
} from "react";

import getDay from "../function/getDay.js";
import getUrl from "../function/getUrl.js";
import checkLogin from "../function/checkLogin.js";
import birthdayToAge from "../function/birthdayToAge.js";

//3個月內結束學員
const DashBoard60DaysLeft = (props) => {
  const url = getUrl();
  const token = sessionStorage.getItem("token");
  const [trialList, setTrialList] = useState([]);
  const [coachList,setCoachList]=useState([])
  const [ageList,setAgeList]=useState([])
  const [balanceList,setBalanceList]=useState([])
  const [monthList,setMonthList]=useState([])
  const [monthCountArray,setMonthCountArray]=useState([])
  const filterInitial = {
    balance: "全部",
    age: "全部",
    coachName: "全部",
    month:"全部",
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "balance":
        return { ...state, balance: action.value };
      case "age":
        return { ...state, age: action.value };
      case "coachName":
        return { ...state, coachName: action.value };
      case "month":
        return { ...state, month: action.value };
      case "reset":
        return filterInitial;
      default:  
        return state;
    }
  };
  const [state, dispatch] = useReducer(reducer, filterInitial);

  let today = getDay(0, "-");
  if (!checkLogin()) {
    window.location.href = "/logout";
  }

  useEffect(async () => {
   const result= await fetch(`${url}/appGet/Get60DaysLeft?token=${token}`)
      .then((res) => res.json())

      //增加 checked 屬性
      for (let i = 0; i < result.length; i++) {
        result[i].checked=false
      }
       
    setTrialList(result)
    //整理 result 內的教練名單
    let coachArray=[]
    result.forEach((item)=>{
      if(!coachArray.includes(item.coachName)){
        if (item.coachName!=="" && item.coachName!==null && item.coachName!=undefined){
                    coachArray.push(item.coachName)
        }
        
      }
    })
    
    //排序
    coachArray.sort()
    // coachArray.push("未設定")
    setCoachList(coachArray)
    //整理 result 內的班別名單
    let ageArray=[]
    result.forEach((item)=>{
      if(!ageArray.includes(item.age)){
        ageArray.push(item.age)
      }
    })
    //排序
    ageArray.sort()
    setAgeList(ageArray)
    //整理 result 內的學員餘額
    let balanceArray=[]
    result.forEach((item)=>{
      if (item.flag) return null
        
      
      if(!balanceArray.includes(item.balance)){
        balanceArray.push(item.balance)
      }
    })
   
    //balanceArray 全部轉數字
    balanceArray=balanceArray.map((item)=>{
      return Number(item)
    })
    //加入 1-4 在最前面
    balanceArray.unshift("1-4")
     
    //排序
    setBalanceList(balanceArray.sort( (a, b) => a - b))

    //整理 result 內的月份
    let monthArray=[]
    result.forEach((item)=>{
      let month=item.studentLastDate.split("-")[1]
      if(!monthArray.includes(month)){
        monthArray.push(month)
      }
    })
    //排序
    monthArray.sort( (a, b) => a - b)
    setMonthList(monthArray)
    console.log(result)
    console.log(coachArray)
    console.log(ageArray)
    console.log(balanceArray)

     //計算每個月 轉正式的人數
     let checkOrderStudentList = []
   let monthCount = {};
    result.forEach(item => {
      let month = item.studentLastDate.split("-")[1];
      if (!monthCount[month] ) {
        monthCount[month] = {
          total: 0,
          flagCount: 0
        };
      }
        monthCount[month].total++;
      if ( item.flag=="yes") {
       monthCount[month].flagCount++;
        checkOrderStudentList.push(item.studentDBID)
      }
     
    });
    console.log("checkOrderStudentList",checkOrderStudentList);
  
  // monthCount 轉成 array
    let tempMonthCountArray = [];
    for (let month in monthCount) {
      tempMonthCountArray.push({
        month: month,
        total: monthCount[month].total,
        flagCount: monthCount[month].flagCount
      });
    }
    tempMonthCountArray.sort((a, b) => a.month - b.month);
    console.log(tempMonthCountArray);
    setMonthCountArray(tempMonthCountArray);

  },[])
 
  return (
    <>
      <div className="card" style={{ width: "18rem;" }}>
         {/* <div className="row">
          <table className="table table-striped">
            <thead className="text-center">
              <tr>
                <th scope="col">月份</th>
                <th scope="col">轉正式人數</th>
                <th scope="col">總人數</th>
                <th scope="col">轉正式率</th>
              </tr>
            </thead>
            <tbody className="text-center">
            {monthCountArray.map((item)=>{
              return(
                <tr key={item.month}>
                  <td>{item.month}月</td>
                  <td>{item.flagCount}</td>
                  <td>{item.total}</td>
                  <td>{((item.flagCount/item.total)*100).toFixed(2)}%</td>
                </tr>
              )
            })}
            </tbody>
          </table>
         
          </div> */}
        <div className="card-header">三個月內正式學員期名單-未購買</div>
        <div className="card-body"> 
       
          <div className="row">
      <table class="table table-striped">
          <thead>
            <tr className="text-center">
              {/* <th scope="col">凍結</th> */}
              <th scope="col">序號</th>
              <th scope="col">編號</th>
              <th scope="col">姓名/暱稱</th>
              <th scope="col">倒數堂數 <select onChange={(e)=>{
                dispatch({type:"balance", value:e.target.value})
              }}>
              <option>全部</option>
              {balanceList.map((item)=>{
                return(
                  <option value={item}>{item}</option>
                )
              })}
            </select>

              </th>
              <th scope="col">會籍日期
                <select onChange={(e)=>{
                  dispatch({type:"month", value:e.target.value})
                }}>
                  <option>全部</option>
                  {monthList.map((item)=>{
                    return(
                      <option value={item}>{item}月</option>
                    )
              })}
            </select>
              </th>
              <th scope="col">上次日期</th>
              <th scope="col">上次時間</th>
              <th scope="col">上次班別<select onChange={(e)=>{
                  dispatch({type:"age", value:e.target.value})
                }}>
                  <option>全部</option>
                  {ageList.map((item)=>{
                    return(
                      <option value={item}>{item}</option>
                    )
              })}
            </select>

              </th>
              <th scope="col">教練<select onChange={(e)=>{
                  dispatch({type:"coachName", value:e.target.value})
                }}>
                  <option>全部</option>
                  {coachList.map((item)=>{
                    return(
                      <option value={item}>{item}</option>
                    )
              })}
            </select>

              </th>
              <th scope="col">下次日期</th>
              <th scope="col">下次時間</th>
              <th scope="col">下次班別</th>
               {/* <th scope="col">符合循環條件</th> */}
            </tr>
                 
          </thead>
         
          <tbody className="text-center">
            {trialList.map((item, index) => {
              if (item.flag){
                return null
              }
              if (!item.checked){
              if (state.balance != "全部" ){
                if (state.balance == "1-4" ){
                  console.log("1-4",item.balance)
                  if (Number(item.balance)>4) return null;
                }else{
                  if (item.balance != state.balance) return null;
                }
              }

              

               if (state.age != "全部" ){
                if (item.age != state.age) return null;
              }

              if (state.coachName != "全部" ){
                if (state.coachName == "未設定" ){
                  console.log("未設定",item.coachName)
                  if (item.coachName!=undefined) {
                    console.log("未設定不等於undefined",item.coachName)
                    return null
                  }
                }else if (item.coachName != state.coachName) return null;
              }
              if (state.month != "全部" ){
                let month=item.studentLastDate.split("-")[1]
                if (month != state.month) return null;
              }

                }

              
            return (
            <tr >
              {/* <td className="text-center">
              <input type="checkbox" checked={item.checked} onChange={()=>{
                let newTrialList=[...trialList]
                newTrialList[index].checked=!newTrialList[index].checked
                setTrialList(newTrialList)
              }} />
              </td> */}
              <td  className="text-center">{index+1}</td>
               <td  className="text-center">{item.studentDBID}</td>
              <td className="text-center" ><a href={`/SingleStudentView/${item.studentDBID}`} style={{textDecoration: 'none'}} >{item.name}</a></td>
              <td className="text-center">{item.balance}</td>
              <td className="text-center">{item.studentLastDate}</td>
              <td className="text-center">{item.classDate}</td>
               <td className="text-center">{item.classTime}</td>
                <td className="text-center">{item.age}</td>
              <td className="text-center">{item.coachName}</td>
              <td className="text-center">{item.nextClassDate}</td>
              <td className="text-center">{item.nextClassTime}</td>
              <td className="text-center">{item.nextAge}</td>
              {/* <td className="text-center">{item.flag}</td> */}
            </tr>)
})}


            
          </tbody>
        </table>

          </div>
             <div className="card-header">三個月內正式學員期名單-已購買</div>
          <div className="row">
      <table class="table table-striped">
          <thead>
            <tr className="text-center">
              {/* <th scope="col">凍結</th> */}
              <th scope="col">序號</th>
              <th scope="col">編號</th>
              <th scope="col">姓名/暱稱</th>
              {/* <th scope="col">倒數堂數 <select onChange={(e)=>{
                dispatch({type:"balance", value:e.target.value})
              }}>
              <option>全部</option>
              {balanceList.map((item)=>{
                return(
                  <option value={item}>{item}</option>
                )
              })}
            </select>

              </th> */}
              <th scope="col">會籍日期
                <select onChange={(e)=>{
                  dispatch({type:"month", value:e.target.value})
                }}>
                  <option>全部</option>
                  {monthList.map((item)=>{
                    return(
                      <option value={item}>{item}月</option>
                    )
              })}
            </select>
              </th>
              <th scope="col">上次日期</th>
              <th scope="col">上次時間</th>
              <th scope="col">上次班別<select onChange={(e)=>{
                  dispatch({type:"age", value:e.target.value})
                }}>
                  <option>全部</option>
                  {ageList.map((item)=>{
                    return(
                      <option value={item}>{item}</option>
                    )
              })}
            </select>

              </th>
              <th scope="col">教練<select onChange={(e)=>{
                  dispatch({type:"coachName", value:e.target.value})
                }}>
                  <option>全部</option>
                  {coachList.map((item)=>{
                    return(
                      <option value={item}>{item}</option>
                    )
              })}
            </select>

              </th>
              <th scope="col">下次日期</th>
              <th scope="col">下次時間</th>
              <th scope="col">下次班別</th>
               {/* <th scope="col">符合循環條件</th> */}
            </tr>
                 
          </thead>
         
          <tbody className="text-center">
            {trialList.map((item, index) => {
              if (!item.flag){
                return null
              }
              if (!item.checked){
              if (state.balance != "全部" ){
                if (item.balance != state.balance) return null;
              }

            

               if (state.age != "全部" ){
                if (item.age != state.age) return null;
              }

              if (state.coachName != "全部" ){
                if (state.coachName == "未設定" ){
                  console.log("未設定",item.coachName)
                  if (item.coachName!=undefined) {
                    console.log("未設定不等於undefined",item.coachName)
                    return null
                  }
                }else if (item.coachName != state.coachName) return null;
              }
              if (state.month != "全部" ){
                let month=item.studentLastDate.split("-")[1]
                if (month != state.month) return null;
              }

                }

              
            return (
            <tr >
              {/* <td className="text-center">
              <input type="checkbox" checked={item.checked} onChange={()=>{
                let newTrialList=[...trialList]
                newTrialList[index].checked=!newTrialList[index].checked
                setTrialList(newTrialList)
              }} />
              </td> */}
              <td  className="text-center">{index+1}</td>
               <td  className="text-center">{item.studentDBID}</td>
              <td className="text-center" ><a href={`/SingleStudentView/${item.studentDBID}`} style={{textDecoration: 'none'}} >{item.name}</a></td>
              {/* <td className="text-center">{item.balance}</td> */}
              <td className="text-center">{item.studentLastDate}</td>
              <td className="text-center">{item.classDate}</td>
               <td className="text-center">{item.classTime}</td>
                <td className="text-center">{item.age}</td>
              <td className="text-center">{item.coachName}</td>
              <td className="text-center">{item.nextClassDate}</td>
              <td className="text-center">{item.nextClassTime}</td>
              <td className="text-center">{item.nextAge}</td>
              {/* <td className="text-center">{item.flag}</td> */}
            </tr>)
})}


            
          </tbody>
        </table>

          </div>
        </div>
      </div>

    </>
  );
};

export default DashBoard60DaysLeft;
